import { Card } from "imagine-ui";
import {
  Address,
  AddressInfo,
  AddressInfoCards,
  DefectsApi,
  EditButton,
  NavigateBack,
  Project,
  ProjectInfo,
  ProjectsApi,
} from "punchlist";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const AddressInfoContainer = () => {
  const params = useParams();
  const { t } = useTranslation();

  const [errorMessage, setErrorMessage] = useState("");
  const [address, setAddress] = useState<Address | undefined>(undefined);

  const loadAddress = useCallback(async () => {
    console.log("Loading address", params);
    if (params.addressCode) {
      const addressCode = params.addressCode;
      console.log("Loading address", addressCode);
      const response = await DefectsApi.getAddress(addressCode);
      if (response.success && response.data) {
        setAddress(response.data);
        console.log("Loaded address", response.data);
        return;
      } else {
        setErrorMessage(t("punchlist:addressNotFound"));
      }
    }
  }, [params]);

  const approveAddress = async () => {
    if (!address) return;

    const response = await ProjectsApi.approveAddress(address.id);
    if (response.success) {
      loadAddress();
      setErrorMessage("");
    } else {
      setErrorMessage(t("punchlist:approveAddressFailed"));
    }
  };

  useEffect(() => {
    loadAddress();
  }, [loadAddress]);

  return (
    <>
      {address && (
        <AddressInfoCards
          address={address}
          errorMessage={errorMessage}
          defectInfoUrl={"/" + params.addressCode + "/"}
          createDefectUrl={"/" + params.addressCode + "/create"}
          onApprove={approveAddress}
        />
      )}
    </>
  );
};
